import PropTypes from "prop-types";
import { Table } from "antd";
import DateSearchHero from "../heros/DateSearchHero";
import { itemRender, onShowSizeChange } from "../Pagination";

function SearchDateTable(props) {
  const { data, isLoading, handleDate, columns, title, query, type } =
    props;

  return (
    <div className="card-box">
      <DateSearchHero handleDate={handleDate} query={query} type={type}/>
      <div>
        {data?.length ? (
          <h5>
            {data?.length + ` ${title} found`}
          </h5>
        ) : null}
      </div>
      <div className="table-responsive">
        <Table
          pagination={{
            total: data?.length,
            showSizeChanger: true,
            onShowSizeChange: onShowSizeChange,
            itemRender: itemRender,
          }}
          columns={columns}
          dataSource={data ?? []}
          // rowSelection={rowSelection}
          // rowKey={(record) => record.id}
          loading={isLoading}
        />
      </div>
    </div>
  );
}

SearchDateTable.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array,
  isLoading: PropTypes.bool,
  handleDate: PropTypes.func,
  title: PropTypes.string,
  setSelecteditemsList: PropTypes.func,
  query: PropTypes.string,
  type:PropTypes.string
};

export default SearchDateTable;
